export default "__VITE_ASSET__DfNDS0Ma__"